import React, { useState } from "react";
import { formatTime, toBool } from "../../JS/utility";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";

const ResReservation3b = (props) => {

    const { t } = props
    const [openDrower, setOpenDrawer] = useState([])
    const [selectedTimeData, setSelectedTimeData] = useState({
        "createReservationBody": {
            "dateTime": "",
            "areaId": null,
            "ruleId": null,
            "menuId": null
        }
    });

    const handleRadioClick = (time, data) => {
        setSelectedTimeData((prevState) => ({
            createReservationBody: {
                ...prevState.createReservationBody,
                dateTime: time,
                areaId: data.areaId,
                ruleId: data.ruleId,
                menuId: data.menuId,
            },
        }));
    }


    const handleDrawer = (id) => {
        const updatedDrawer = openDrower.includes(id)
            ? openDrower.filter((drawerId) => drawerId !== id)
            : [...openDrower, id];

        setOpenDrawer(updatedDrawer);
    }

    const handleNext = () => {

        if(!selectedTimeData.createReservationBody.ruleId){
            props.popupOpenClose(true, "Please choose an available time")
            return;
        } else {
            props.next(selectedTimeData)
        }
    }

    React.useEffect(() => {
        if (props.restaurantsAvailability.length == 1) {
            setOpenDrawer([props.restaurantsAvailability[0].areaId])
        }

        if (props.createReservationData.createReservationBody.dateTime) {

            let checkIfTimeAvail = props.restaurantsAvailability.some((area) =>
            area.sittings.some((timeData) =>
              timeData.available && timeData.time === props.createReservationData.createReservationBody.dateTime
            )
          );

          if(checkIfTimeAvail || (props.customerExistingReservationData && props.customerExistingReservationData.dateTime == props.createReservationData.createReservationBody.dateTime)){
            handleRadioClick(props.createReservationData.createReservationBody.dateTime, props.createReservationData.createReservationBody)
          }
        }
    }, [])

    return (
        <>
            <section class="widgets">
                <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                    <h2>{props.subHeading}</h2>
                </div>
                <div class="form-window">
                    <div class="form-window-heading">{t('resReservation.res_details')}</div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
                        <p>{t('resReservation.select_prefer_time')}</p>

                        {
                            props.restaurantsAvailability.map((area) => {
                                return props.areaList.map((requiredArea) => {
                                    if (requiredArea.id == area.areaId) {
                                        return (
                                            <div key={area.areaId} class="form-row">
                                                <div class={`drawer ${openDrower.some((areaId) => areaId == area.areaId) && "open"}`}>
                                                    <div class="drawer-header" onClick={() => handleDrawer(area.areaId)}>
                                                        <div class="drawer-icons" >
                                                            <span class="fa fa-chevron-up"></span>
                                                            <span class="fa fa-chevron-down"></span>
                                                        </div>
                                                        <label>{requiredArea.description}</label>
                                                    </div>
                                                    {
                                                        openDrower.includes(area.areaId) &&
                                                        area.sittings.map((time) => {
                                                            return (
                                                                <div class="drawer-body">
                                                                    {(time.available || (props.customerExistingReservationData && props.customerExistingReservationData.dateTime == time.time)) && <label><input type="radio" name="timeOptions" class="margin-right-1" checked={selectedTimeData.createReservationBody.dateTime == time.time && area.areaId == selectedTimeData.createReservationBody.areaId} onChange={() => handleRadioClick(time.time, area)} />{formatTime(time.time, toBool(props.timeFormat), props.gmtOffset)}</label>}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                })
                            })
                        }

                    </div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <div class="form-controls">
                            <button class="primary w-100 margin-bottom-1" onClick={() => handleNext()} >{t('resReservation.next')}</button>
                            <button class="secondary w-100" onClick={() => props.close()} >{t('resReservation.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    }
}

export default connect(mapStateToProps, {popupOpenClose})(withTranslation('translations')(ResReservation3b));